import connect from 'components/Shared/connect';
import { isLayout, isMobile, isTablet } from 'components/Shared/responsive';
import styles from './styles.scss';
import cn from 'classnames';
import MobileMenu from '../BGH-RD3/mobile';
import DesktopMenu from './desktop';

interface OwnProps {
  className: string;
}
interface MergedProps extends OwnProps {
  isDrawer: boolean;
}

export default connect<MergedProps, OwnProps>(state => ({
  isDrawer: isLayout(isMobile, isTablet)(state)
}))(({ isDrawer, className }) => {
  return (
    <div className={cn(className, styles.base)}>
      {isDrawer && <MobileMenu />}
      {!isDrawer && <DesktopMenu />}
    </div>
  );
});
